import React, { Component } from "react";

export default class LeadOptimizationService extends Component {
  constructor(props) {
    super();

    this.state = {
      baseMessage: (
        <div>
          Agencies cannot write this business classification via My Commercial
          Exchange at this time.
        </div>
      ),
      rerouteMessage: (
        <div>
          For Allstate agents: Please consider{" "}
          {
            <a
              href={
                "https://ivantage.my.salesforce.com/sfc/p/#G0000000jDz6/a/1L000000RO1E/QaMFnsU2QiVMj4VDgKLDb8c2D4Xzx16vO7SPQ4LxYY8"
              }
              target="_blank"
              rel="noreferrer"
            >
              submitting your lead to the Business Insurance Specialist Team
            </a>
          }{" "}
          as they might be able to place this risk on your behalf.
          <br />
          <br />
          For non-Allstate agents: Thank you for quoting. We hope to be able to
          help you and your customers with this type of business in the future.
        </div>
      ),
      hardstopMessage: (
        <div>
          Thank you for quoting. We hope to be able to help you and your
          customers in the future.
        </div>
      ),
    };
  }

  render() {
    return (
      <div>
        <p>
          {this.state.baseMessage}
          <br />
          {this.props.inefficencyType === "Reroute"
            ? this.state.rerouteMessage
            : this.state.hardstopMessage}
        </p>
      </div>
    );
  }
}
